import React from 'react';
import {Link, useLocation} from "react-router-dom";

function HeaderLogo() {
  return (
    <div>
      <Link to={'/'} className="header-logo-wrapper">
        <img className="header-logo-container" src="/asset/main_logo_1.png" />
        <span className="seperator"></span>
        <img className="header-logo-container" src="/asset/logo-jorakay-02.png" />
      </Link>
    </div>
  );
}

export default HeaderLogo;
